exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".add-to-wallet, .add-to-wallet * {\r\n    cursor: pointer;\r\n}", ""]);

// exports
